module.exports = __webpack_public_path__ + "static/media/welcome-slider-3-en-sm.8b224227.png";